module.exports = __webpack_public_path__ + "1def85c2510c8cdb865279c0a9d0c7ec.pdf";